<script setup>
import { computed, ref } from "vue";

const props = defineProps({
    expert: {
        type: Object,
        required: true,
    },
});

const avatarFailed = ref(false);

// Fallback to the expert's initial when the avatar is missing or fails to load.
const initial = computed(
    () => props.expert.name?.charAt(0).toUpperCase() ?? "?",
);
</script>

<template>
    <a :href="expert.profile_url" class="group flex items-start gap-4">
        <span
            class="grid size-[70px] shrink-0 place-items-center overflow-hidden rounded-brand bg-brand-navy/10 font-brand text-[24px] font-bold text-brand-navy/60"
        >
            <img
                v-if="expert.avatar && !avatarFailed"
                :src="expert.avatar"
                :alt="expert.name"
                class="size-full object-cover"
                @error="avatarFailed = true"
            />
            <span v-else aria-hidden="true">{{ initial }}</span>
        </span>

        <div class="flex min-w-0 flex-1 flex-col">
            <div class="flex items-start justify-between gap-2">
                <span
                    class="font-brand text-[17px] font-semibold leading-[1.2] text-[#102a3d] transition-colors group-hover:text-brand-red"
                >
                    {{ expert.name }}
                </span>
                <svg
                    viewBox="0 0 12 14"
                    class="mt-1 h-3.5 w-3 shrink-0 text-brand-red"
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linejoin="round"
                    aria-hidden="true"
                >
                    <path d="M3 2.5 L9.5 7 L3 11.5 Z" />
                </svg>
            </div>

            <p
                v-if="expert.description"
                class="mt-1.5 line-clamp-3 font-brand text-[12px] leading-[1.35] text-[#565a77]"
            >
                {{ expert.description }}
            </p>
        </div>
    </a>
</template>
